/* TargetDevicesListComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./TargetDevicesListRenderer");
const _ = require("lodash");

class TargetDevicesListComponent extends EventEmitter {
    constructor(logger, gameEditor, state) {
        super();

        this._logger = logger;
        this._gameEditor = gameEditor;

        this._configExecutionEntity = _.get(state, "configExecutionEntity", undefined);
        this._deviceEntityDef = _.get(state, "deviceEntityDef", undefined);
        this._CustomFieldsEntityClass = _.get(state, "customFieldsEntityDef", undefined);
        this._customFieldsWithInherited = {};
        this._customFieldsEntityInstance = {};
        this._workEntity = undefined;

        this._isMethodQuery = _.get(this._configExecutionEntity, "_pristineProperties.deviceTarget.method", "") === "query";

        this._query = {};
        if (this._isMethodQuery) {
            this._query = _.get(this._configExecutionEntity, "_pristineProperties.deviceTarget.query", {});
        }

        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    whenModelIsReady() {
        return this._gameEditor
            .whenPolicyIsReady()
            .then(() => {
                return this._configExecutionEntity.loadRelatedWork({ targets: true });
            })
            .then((workEntity) => {
                this._workEntity = workEntity;
                return this.retrieveCustomFieldsEntity(this._gameEditor._activeOrgId);
            });
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._logger = undefined;
        this._gameEditor = undefined;
        this._configExecutionEntity = undefined;
        this._workEntity = undefined;
        return Promise.resolve(prom).then(() => {
            if (this._workEntity) {
                return this._workEntity.shutdown();
            }
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    get logger() {
        return this._logger;
    }

    getTargetResultsRows() {
        if (!this._workEntity) {
            return {};
        } else {
            let targets = _.get(this._workEntity, "targets", {});
            _.forEach(targets, (target) => {
                target.ip = _.get(target, ["connectionInformation", "ip"], "");
            });
            return targets;
        }
    }

    setCustomFieldsEntity(newOrgInstance) {
        this._customFieldsEntityInstance = newOrgInstance;
        return this._customFieldsEntityInstance;
    }

    retrieveCustomFieldsEntity(tenantId) {
        if (this._customFieldsEntityInstance && this._customFieldsEntityInstance.shutdown) {
            this._customFieldsEntityInstance.shutdown().catch((error) => this._logger.warn({ error }));
        }
        return this._CustomFieldsEntityClass
            .retrieveCustomFields(tenantId)
            .then((customFieldsEntity) => {
                this.setCustomFieldsEntity(customFieldsEntity);
                return customFieldsEntity.loadInheritedFields();
            })
            .then((inheritedFields) => {
                Object.assign(this._customFieldsWithInherited, this._customFieldsEntityInstance.fields, inheritedFields);
                return this._customFieldsWithInherited;
            });
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = TargetDevicesListComponent;

TargetDevicesListComponent.$inject = ["$teve.logger", "gameEditor.gameEditor", "gameEditor.viewState"];

TargetDevicesListComponent.$displayDetails = {
    type: "View",
    name: "Target Devices List",
    icon: "common.edit",
    shown: false
};
